<template>
  <v-snackbar top
              right
              vertical
              text
              outlined
              elevation="4"
              app
              transition="scroll-y-transition"
              :value="visible"
              :color="color"
              :timeout="timeout"
              @input="close">
    <div v-html="message" style="font-size:1rem;line-height:1.4"/>
    <template v-slot:action="{ attrs }">
      <v-btn class="mr-1 mb-1 mt-2 px-3" v-bind="attrs" @click="close" :color="color" elevation="0" style="height:27px;min-width:auto">
        {{ $t('cove.general.close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>

export default {
  data () {
    return {
      timeout: 5000
    };
  },
  computed: {
    visible () {
      return this.$store.state.cove.snackbar.visible;
    },
    message () {
      return this.$store.state.cove.snackbar.message;
    },
    color () {
      return this.$store.state.cove.snackbar.color;
    },
    isDark () {
      return this.$vuetify.theme.isDark;
    }
  },
  methods: {
    close () {
      this.$store.commit('cove/snackbar/setVisible', false);
    }
  }
};
</script>